<template>
  <v-card>
    <v-card-title>{{$t('Appointment Details')}}</v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <v-alert
        class='mt-5'
        dense
        outlined
        type="info"
      >
        {{$t('You appointment has not been scheduled yet. Please carefully review your information below.')}}

      </v-alert>
      <div class='ma-3'>
        <p class='subtitle-1'><b> {{$t('Who')}}:</b> {{getGCName(selectedGC)}}</p>
        <p class='subtitle-1'><b>{{$t('When')}}:</b> {{selectedDate}} {{$moment(selectedTime).format("hh:mm")}}</p>
        <p class='subtitle-1'><b>{{$t('Reason for Appointment')}}:</b> {{getReason(form.reason)}}</p>
        <p class='subtitle-1'><b>{{$t('Notes')}}:</b> {{form.notes}} </p>
        <v-divider></v-divider>
        <p class='subtitle-1'><b>{{$t('Name')}}:</b> {{form.firstName}} {{form.lastName}} </p>
        <p class='subtitle-1'><b>{{$t('Gender')}}:</b> {{form.gender}} </p>
        <p class='subtitle-1'><b>{{$t('DOB')}}:</b> {{form.dob}} </p>
        <p class='subtitle-1'><b>{{$t('Email Address')}}:</b> {{form.email}} </p>
        <p class='subtitle-1'><b>{{$t('Address')}}:</b> {{form.address}} </p>
        <p class='subtitle-1'><b>{{$t('Phone')}}:</b> {{form.phone}} </p>
        <p class='subtitle-1'><b>{{$t('Second Phone')}}:</b> {{form.secondPhone}} </p>
        <p class='subtitle-1'><b>{{$t('Time Zone')}}:</b> {{form.timezone.name}} </p>

      </div>
    </v-card-text>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        text
        @click='$emit("back")'
      >
        <v-icon
          right
          dark
        >
          mdi-chevron-left
        </v-icon>
        {{$t('Back')}}
      </v-btn>
      <v-btn
        class='gsfBtn'
        @click='$emit("next")'
        text
      >
        {{$t('Payment')}}<v-icon
          right
          dark
        >
          mdi-chevron-right
        </v-icon>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { reasonList } from "../data/dataSource";
import { Gc_pic_url } from "../utilities";
import { mapFields } from "vuex-map-fields";
export default {
  methods: {
    getReason(id) {
      return reasonList().find((i) => i.value === id).name;
    },
    getGCName(gcID) {
      return Gc_pic_url(gcID).name;
    },
  },
  computed: {
    ...mapFields([
      "form",
      "allApptType",
      "selectedStateID",
      "avaiableDates",
      "avaiableTimes",
      "selectedMonth",
      "selectedDate",
      "selectedGC",
      "selectedTime",
    ]),
  },
};
</script>

<style>
</style>